
const notification = {
    state: {
        dogPurchaseRequestCount: 0,
        orderForDeliveryCount: 0
    },
    mutations: {
        setDogPurchaseNotification(state, dogPurchaseRequestCount) {
            state.dogPurchaseRequestCount = dogPurchaseRequestCount;
        },
        setOrderNotification(state, orderForDeliveryCount) {
            state.orderForDeliveryCount = orderForDeliveryCount;
        }
    },
    actions: {

    },
    getters: {
        getDogPurchaseNotification(state) {
            return state.dogPurchaseRequestCount;
        },
        getOrderNotification(state) {
            return state.orderForDeliveryCount;
        }
    }
}

export default notification;